export const getNewRelicSessionId = (): string | null => {
  const nrbaSession = localStorage.getItem('NRBA_SESSION');
  if (!nrbaSession) {
    console.warn('NRBA_SESSION does not exist');
    return null;
  }

  try {
    const parsedSession = JSON.parse(nrbaSession);
    return parsedSession.value;
  } catch (error) {
    console.warn('Failed to parse NRBA_SESSION', error);
    return null;
  }
};
export const getNewRelicTraceId = (request: any | XMLHttpRequest): string | undefined => {
  if (!request || typeof request !== 'object') {
    return undefined;
  }
  const contextKey = Object.getOwnPropertyNames(request)[0];
  if (!contextKey) {
    return undefined;
  }
  return request[contextKey]?.dt?.traceId;
};

// Distributed-trace id of the most recent API request. A render crash has no
// trace id of its own, so the crash screen surfaces the last request's id to
// correlate with backend Transactions/Logs (which carry the same `trace.id`).
let lastTraceId: string | undefined;

export const setLastTraceId = (id?: string): void => {
  if (id) lastTraceId = id;
};

export const getLastTraceId = (): string | undefined => lastTraceId;
